import styled from 'styled-components';

const Container = styled.div`
	margin: 0 0 40px 0;
`;

const Label = styled.p`
	font-size: 12px;
	color: #9B9B9B;
	margin: 0 0 8px;
`;

export {
	Container,
	Label
}
